import { createSlice } from "@reduxjs/toolkit";

export const countriesSlice = createSlice({
  name: 'countries',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startCountries: (state) => { state.isLoading = true },
    setCountries: (state, { payload: { data = null, error = null } }) => {
      state.data = data ?? null;
      state.error = error ?? null;
      state.isLoading = false;
    }
  }
});


export const { startCountries, setCountries } = countriesSlice.actions;
